/**
 * Normalize the argument based on comparator semantics.
 * - For 'in': ensure the argument is an array (wrap singletons, [] for nullish)
 * - For others: ensure the argument is not an array (use first element or undefined)
 */
export type NormalizedArgument =
  | string
  | number
  | boolean
  | Array<string | number | boolean>
  | null
  | undefined;

export function normalizeComparatorArgument(
  comparatorId: string | undefined,
  argument: unknown
): NormalizedArgument {
  if (comparatorId === 'in') {
    if (Array.isArray(argument))
      return argument as Array<string | number | boolean>;
    return argument != null
      ? ([argument] as Array<string | number | boolean>)
      : [];
  }

  if (Array.isArray(argument)) {
    return (argument as Array<string | number | boolean>).length > 0
      ? (argument as Array<string | number | boolean>)[0]
      : undefined;
  }
  return argument as string | number | boolean | null | undefined;
}
